import * as React from 'react'

import { Text, Dott } from '@lightspeed/design-system-react'

type DottMessageProps = {
  children: React.ReactNode
}

export const DottMessage: React.FC<DottMessageProps> = ({ children }) => (
  <div className="vd-bg-framing vd-flex vd-pt5">
    <div className="vd-mr4">
      <Dott />
    </div>
    <Text type="label">{children}</Text>
  </div>
)
